export const REAL_ASSET_TYPE_PROPERTY = 'property';
export const REAL_ASSET_TYPE_PERSONAL_ASSET = 'personalAsset';
export const REAL_ASSET_TYPE_VEHICLE = 'vehicle';
export const REAL_ASSET_TYPE_BUSINESS = 'businessOwnership';
export const REAL_ASSET_QUERY_VALUE_ID = 'id';
export const REAL_ASSET_QUERY_VALUE_TYPE = 'type';
export const REAL_ASSET_QUERY_VALUE_WITH_DELETE = 'withDelete';
